import { gql } from '@apollo/client';
import Fragments from '../fragments/fragments';
import UserInfoFragments from 'features/userProfile/fragments/fragments';

export const DOCUMENT_COMMENT_ADDED = gql`
  subscription documentCommentAdded($documentId: Int!, $siteId: Int!, $userPartnerId: Int!, $commentIsDirty: Boolean!, $userId: Int!) {
    documentCommentAdded(documentId: $documentId, siteId: $siteId, userPartnerId: $userPartnerId, commentIsDirty: $commentIsDirty, userId: $userId) {
      documentId
      siteId
      userId
      list {
        ...comment
      }
      usersAdditionalData {
        ...userAdditionalData
      }
    }
  }
  ${Fragments.comment}, ${UserInfoFragments.userAdditionalData}
`;

export const DOCUMENT_COMMENT_UPDATED = gql`
  subscription documentCommentUpdated($documentId: Int!, $siteId: Int!, $userPartnerId: Int!) {
    documentCommentUpdated(documentId: $documentId, siteId: $siteId, userPartnerId: $userPartnerId) {
      ...comment
    }
  }
  ${Fragments.comment}
`;

export const DOCUMENT_COMMENT_DELETED = gql`
  subscription documentCommentDeleted($documentId: Int!, $siteId: Int!, $userPartnerId: Int!) {
    documentCommentDeleted(documentId: $documentId, siteId: $siteId, userPartnerId: $userPartnerId) {
      ...comment
    }
  }
  ${Fragments.comment}
`;
